module.exports = __webpack_public_path__ + "img/solution_store1.13243b01.png";